export default __webpack_public_path__ + "media/src/assets/images/WarehouseColor-ebd5c8e7a87383b25d7dbeb2fdba64dc.svg";